module.exports = __webpack_public_path__ + "media/pro/CE_DB-4c713159.png";